import type {DefaultValuesById} from '../types'

type SafeGetDefaultValueType = {
  id?: string | null
  indexOfFormElement?: number
  value?: string | null
} & DefaultValuesById

export const GENERATED_FIELD_PREFIX = 'template-field'

export const safeGetDefaultValue = ({id, indexOfFormElement, value, defaultValuesById}: SafeGetDefaultValueType) => {
  // ID and value are undefined/nullable to be compliant with the graphQL return payload, as these fields
  // on the elements (textarea for example) are optional.
  let defaultEnforcedValue = defaultValuesById && id ? defaultValuesById[id] : undefined

  // If a field doesn't have an ID, Copilot will generate an ID. Get the generated ID if present:
  if (defaultEnforcedValue === undefined && defaultValuesById && indexOfFormElement !== undefined) {
    defaultEnforcedValue = defaultValuesById[`${GENERATED_FIELD_PREFIX}-${indexOfFormElement}`]
  }

  return defaultEnforcedValue ?? value ?? ''
}
